import * as Popover from "@radix-ui/react-popover";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { joinClassNames } from "@utils/helpers";

interface Filter {
  Group: string;
  Key: string;
  Value: string;
  Label: string;
}

interface FacetItem {
  QKey: string;
  QValue: string;
  Label: string;
  Count: number;
}

interface Facet {
  Label: string;
  Items: FacetItem[];
}

interface Props {
  values: Filter[];
  options: Facet[];
  onAdd: (option: FacetItem) => void;
  onRemove: (option: FacetItem) => void;
}

export default function Filter({ values, options, onAdd, onRemove }: Props) {
  return (
    <div className="-mx-4 flex items-center gap-2 divide-x">
      {options
        .filter((option) => option.Items.length > 0)
        .map((option) => (
          <div key={option.Label} className="px-4 flex gap-2">
            <div className="flex gap-2 items-center flex-wrap">
              <Popover.Root>
                <Popover.Trigger className="flex items-center gap-2 text-gray-600">
                  <span className="flex items-center">
                    {option.Label}
                    {values.filter((value) => value.Group === option.Label)
                      .length > 0 ? (
                      <span className="ml-1.5 rounded bg-indigo-100 px-1.5 py-0.5 text-xs font-semibold tabular-nums text-indigo-800">
                        {
                          values.filter((value) => value.Group === option.Label)
                            .length
                        }
                      </span>
                    ) : (
                      <></>
                    )}
                  </span>
                  <ChevronDownIcon className="h-4 w-4" />
                </Popover.Trigger>
                <Popover.Portal>
                  <Popover.Content
                    sideOffset={5}
                    collisionPadding={{ top: 90 }}
                    className="bg-white px-4 pb-2 rounded-lg border w-fit max-h-80 overflow-y-auto ring-1 ring-inset ring-gray-100 shadow"
                  >
                    <p className="sticky top-0 py-2 text-xl font-semibold text-black bg-white/50 backdrop-blur rounded-t-lg">
                      {option.Label}
                    </p>
                    <div className="flex flex-col gap-2">
                      {option.Items.map((item) => (
                        <button
                          key={`${item.QValue}-${item.Label}`}
                          onClick={() => {
                            if (
                              values
                                .filter((value) => value.Group === option.Label)
                                .map((value) => value.Label)
                                .includes(item.Label)
                            ) {
                              onRemove(item);
                              return;
                            }
                            onAdd(item);
                          }}
                          className={joinClassNames(
                            "flex items-center gap-1 w-fit py-1 px-2 rounded-lg text-sm transition-colors ease-in-out duration-200",
                            values
                              .filter((value) => value.Group === option.Label)
                              .map((value) => value.Label)
                              .includes(item.Label)
                              ? "bg-indigo-100 text-indigo-800"
                              : "bg-gray-100 text-gray-800"
                          )}
                        >
                          {item.Label} ({item.Count})
                        </button>
                      ))}
                    </div>
                  </Popover.Content>
                </Popover.Portal>
              </Popover.Root>
            </div>
          </div>
        ))}
    </div>
  );
}
